module.exports = __webpack_public_path__ + "img/Frech.5b6c960a.jpg";